module.exports = __webpack_public_path__ + "img/logo-text-en-dr.054c782.png";